import { Component, OnInit } from '@angular/core';
import {AgentData} from '../../../model/agent-page-data';
import {Review} from '../../../model/review';
import {AgentPageService} from '../agent-page/agent-page.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ReviewsService} from '../../pages/reviews/reviews.service';
import {MatDialog, MatDialogConfig} from '@angular/material';
import {environment} from '../../../../environments/environment';
import {WriteReviewDialogComponent} from '../../modal/write-review-dialog/write-review-dialog.component';
import eq from 'lodash-es/eq';
import split from 'lodash-es/split';
import {SearchboxService} from '../searchbox/searchbox.service';
import {Meta} from '@angular/platform-browser';
import {DataService} from '../../../../shared/shared-data.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-agent-service-page',
  templateUrl: './agent-service-page.component.html',
  styleUrls: ['./agent-service-page.component.scss'],
  providers: [AgentPageService, ReviewsService, SearchboxService]
})
export class AgentServicePageComponent implements OnInit {

  agent: AgentData;
  agentSuffix: string;

  reviews: Review[] = [];
  currentPage = 1;
  itemsPerPage = 20;
  maxSize = 5;
  totalItems = 0;

  chiefPage = false;
  cdnPath: string;

  referralCode: string;
  referredName: string;
  showReferredBlock: boolean = false;

  constructor(private agentPageService: AgentPageService,
              private searchboxService: SearchboxService,
              private route: ActivatedRoute,
              private reviewsService: ReviewsService,
              private dataService: DataService,
              private dialog: MatDialog,
              private router: Router,
              private meta: Meta,
              private modalService: NgbModal) {
  }

  ngOnInit() {
    this.cdnPath = environment.cdnPath;
    this.route.params.subscribe(res => {
      this.agentSuffix = res.agent;
      if (eq(this.agentSuffix, 'igor-fishbeyn') || eq(this.agentSuffix, 'vlad-veinstein')) {
        this.chiefPage = true;
      }
      this.agentPageService.getAgentInfo(this.agentSuffix).subscribe(
        (response: AgentData) => {
          this.agent = response;
          if (this.agent) {
            /* OpenGraph tags */
            /*this.meta.updateTag({
              property: 'og:image',
              content: this.cdnPath + this.agent.image
            }, "property='og:image'");
            this.meta.updateTag({
              property: 'og:image:width',
              content: '158'
            }, "property='og:image:width'");
            this.meta.updateTag({
              property: 'og:image:height',
              content: '158'
            }, "property='og:image:height'");*/
            /* ------ */
            this.loadReviews();
          } else {
            this.router.navigateByUrl('');
          }
        },
        error => {
          console.error('Error during get agent info', error);
        });
    });
    this.initReferralInfo();
  }

  private initReferralInfo() {
    this.route.queryParams.subscribe(params => {
      let referralCode = params['referral_code'];
      if (referralCode) {
          this.searchboxService.getCustomerNameByReferralCode(referralCode)
            .subscribe(response => {
              if (response.status == 'SUCCESSFUL') {
                this.showReferredBlock = true;
                this.referralCode = referralCode;
                this.referredName = response.data.details;
              } else {
                this.showReferredBlock = false;
              }
            });
      }
    });
  }

  private extractImageName(image: string) {
    return split(image, '/').pop().replace('png', 'jpg');
  }

  private loadReviews() {
    this.reviewsService.getReviews(this.currentPage, this.itemsPerPage, this.agent.id).subscribe(
      (response: any) => {
        this.reviews = response.reviewList;
        this.totalItems = response.totalReviews;
      },
      error => {
        console.warn('Error during get reviews');
      });
  }


  loadPage(page: number) {
    window.scrollTo(0, 0);
    this.loadReviews();
  }

  openWriteReviewDialog(): void {
      this.dataService.sendData({type: 'showModal', data: true});
      const dialogRef = this.modalService.open(WriteReviewDialogComponent, {
        windowClass: 'write-review-dialog',
        backdropClass: 'hiw-backdrop'});
      dialogRef.componentInstance.userId = this.agent.id;
      dialogRef.result.then((result) => {
          this.dataService.sendData({type: 'showModal', data: false});
      }, (reason) => {
          this.dataService.sendData({type: 'showModal', data: false});
      });
  }

}
